import React from 'react';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import RecurringExpenseItemDeleteButton from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseItemDeleteButton';

function RecurringExpenseItemAmount({ onDelete, onBlur }) {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  return (
    <FDStack
      direction={isMobile ? 'column' : 'row'}
      padding={2}
      justifyContent={'space-between'}
      spacing={1}
      alignItems={'center'}
      {...dataAttrs('recurring-expense-item')}
      width={'100%'}
    >
      <FDStack
        width={'100%'}
        direction={'row'}
        spacing={1}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <MetaControlField simpleRootStyle attr={'title'} />
        {isMobile ? <RecurringExpenseItemDeleteButton resource={resource} onDelete={onDelete} /> : null}
      </FDStack>
      <FDStack direction={'row'} spacing={1} alignItems={'center'} width={isMobile ? '100%' : undefined} wrap={isMobile}>
        <FDStack direction={'column'} width={'100%'}>
          <MetaControlField attr={'value'} onInlineSubmit={() => onBlur(resource)} simpleRootStyle />
          <MetaControlField attr={'frequencyDescriptor'} />
        </FDStack>
        {isMobile ? null : <RecurringExpenseItemDeleteButton resource={resource} onDelete={onDelete} />}
      </FDStack>
    </FDStack>
  );
}

RecurringExpenseItemAmount.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

RecurringExpenseItemAmount.defaultProps = {
};

export default RecurringExpenseItemAmount;
